import { FormEditActions } from "@arelia-components/form/FormEditActions";
import { Box, Card, CardContent, CardHeader, TextField } from "@mui/material";
import { FormikProps } from "formik";
import { ChangeEvent } from "react";
import { EditForm } from "./SocialsContainer";
import { useHandleFormActions } from "@arelia-hooks/formikHooks";
import { formConfig, iconsMap } from "./constants";
import theme from "src/theme";

type Props = {
  formik: FormikProps<EditForm>;
  editing: boolean;
  setEditing: (editing: boolean) => void;
  handeChange: (name: string) => (event: ChangeEvent<HTMLInputElement>) => void
};

export default function SocialsPresenter({ formik, editing, setEditing, handeChange }: Props) {
  const { handleSubmit, handleReset, handleEdit } = useHandleFormActions<EditForm>(setEditing, formik);

  return (<Card sx={styles.card}>
    <CardHeader
      title="Socials"
      action={<FormEditActions edit={editing} handleEdit={handleEdit} handleReset={handleReset} handleSubmit={handleSubmit} />}
    />
    <CardContent sx={styles.cardContent(editing)}>
      {
        !editing && formik.values && Object.keys(formik.values)
          .filter(name => formik.values[name])
          .map((name, index) =>
            <a href={formik.values[name]} target="_blank" rel="noopener noreferrer" key={index}>
              {iconsMap[name]}
            </a>
          )
      }
      {
        editing && <Box sx={styles.inputsBox}>
          {formConfig.map(({ field, label }, index) =>
            <TextField
              key={index}
              label={label}
              value={formik.values[field] || ""}
              onChange={handeChange(field)}
              size="small"
              fullWidth
            />
          )}
        </ Box>
      }
    </CardContent>
  </Card>);
}

const styles = {
  card: {
    gridColumn: "span 4",
    gridRow: "span 3",
    overflow: "visible",
    zIndex: 2
  },
  cardContent: (editing: boolean) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    height: "100%",
    padding: `${editing ? "0 !important" : "0 30px 30px"}`,
  }),
  inputsBox: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
    padding: "20px 30px 30px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
    backgroundColor: theme.palette.background.paper,
  }
}